import React, { FC, ReactNode } from "react";
import { Checkbox, CheckboxGroup } from "@UI/Components/Checkbox/Checkbox";
import { SimpleGrid } from "@UI/Components/SimpleGrid/SimpleGrid";
import { FormLabel } from "@UI/Components/Form/Form";
import { OptionCard } from "../OptionCard/OptionCard";
import { checkboxControlSx, getOptionControlProps } from "../OptionCard/controlStyles";
import { QuestionFormControl } from "../QuestionFormControl/QuestionFormControl";
import { BaseQuestionProps } from "../types";

export interface MultiSelectOption {
  value: string;
  label: string;
  badge?: ReactNode;
}

export interface MultiSelectQuestionProps extends BaseQuestionProps {
  label?: string;
  options: MultiSelectOption[];
  value: string[];
  onChange: (value: string[]) => void;
  columns?: number;
}

export const MultiSelectQuestion: FC<MultiSelectQuestionProps> = ({
  label,
  options,
  value,
  onChange,
  columns = 2,
  isRequired = false,
  isInvalid = false,
  errorMessage = "",
  isDisabled = false,
}) => (
  <QuestionFormControl
    isRequired={isRequired}
    isInvalid={isInvalid}
    errorMessage={errorMessage}
    isDisabled={isDisabled}
  >
    {label && <FormLabel>{label}</FormLabel>}
    <CheckboxGroup
      value={value}
      onChange={(next) => onChange(next as string[])}
      isDisabled={isDisabled}
    >
      <SimpleGrid columns={columns} spacing={3}>
        {options.map((option) => {
          const isSelected = value.includes(option.value);
          return (
            <OptionCard
              key={option.value}
              isSelected={isSelected}
              isDisabled={isDisabled}
              badge={option.badge}
            >
              <Checkbox
                value={option.value}
                colorScheme="seaGreen"
                spacing="10px"
                sx={checkboxControlSx}
                {...getOptionControlProps(isSelected)}
              >
                {option.label}
              </Checkbox>
            </OptionCard>
          );
        })}
      </SimpleGrid>
    </CheckboxGroup>
  </QuestionFormControl>
);
